import React from "react";
import { CAMPAIGNS } from "../../data/mockData";
import { ArrowRight, Users, TrendingUp } from "lucide-react";

export default function Campaigns() {
  return (
    <div className="p-4 pb-6">
      <h1 className="text-[24px] font-black">Bounty Campaigns</h1>
      <p className="mt-1 text-[12px] text-[#A1A1AA]">Verified operator demand by market.</p>

      <div className="mt-5 space-y-4">
        {CAMPAIGNS.map((c) => (
          <div key={c.id} data-testid={`campaign-${c.id}`} className="sb-card overflow-hidden">
            <div className="relative sb-image-dim h-32">
              <img src={c.image} alt="" className="w-full h-full object-cover" />
              {c.highDemand && (
                <div className="absolute top-3 left-3 sb-pill sb-pill-gold">
                  <TrendingUp size={11} /> High Demand
                </div>
              )}
            </div>
            <div className="p-4">
              <div className="font-black text-[15px] leading-tight">{c.title}</div>
              <div className="mt-1 text-[12px] text-[#A1A1AA]">{c.verticals}</div>
              <div className="mt-3 grid grid-cols-2 gap-2 text-[11px] text-[#A1A1AA]">
                <div className="flex items-center gap-1"><Users size={12} /> {c.employees}</div>
                <div className="text-[#FFC107] font-bold">{c.bounty}</div>
              </div>
              <div className="mt-3 text-[11px] text-[#A1A1AA] italic">{c.note}</div>
              <button className="mt-4 sb-btn-primary w-full text-[11px]" style={{ padding: "10px 14px" }}>
                Start Scouting <ArrowRight size={12} />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
